module.exports = __webpack_public_path__ + "e1648ced184a04bb8a7e592e51653114.MP3";